import { FunctionComponent } from 'react';
import { BodyText } from '@gaiads/telia-react-component-library';
import { createPhoneNumber } from '@cdaas/reusable-components-daas';
import { UserType } from '@cdaas/api-clients/dist/order-openapi';

import { mapCountryValue } from '../../../utils/mappingUtils';

interface ContactOrDeliveryInformationProps {
  customerData: {
    customer_name?: string;
    person: {
      type?: UserType;
      title?: string;
      given_name?: string;
      family_name?: string;
      phone_number?: string;
      country_calling_code?: string;
      email?: string;
    };
    address?: {
      address_1: string;
      address_2?: string;
      address_3?: string;
      city: string;
      country: string;
      zip: string;
    };
  };
  groupTitle: string;
  adminType?: string;
  contactOrDelivery: 'contact' | 'delivery';
}

export const ContactOrDeliveryInformation: FunctionComponent<ContactOrDeliveryInformationProps> = props => {
  return (
    <>
      <BodyText forceWrap size={'xs'} color={'gray500'} margin={{ bottom: 'xxs' }}>
        {props.groupTitle}
      </BodyText>

      {props.contactOrDelivery === 'contact' && (
        <>
          <BodyText forceWrap size={'sm'} margin={{ bottom: 'xxs' }}>
            {props.customerData.person.type === 'ADMIN'
              ? props.adminType || ''
              : `${props.customerData.person.given_name || ''} ${props.customerData.person.family_name || ''}`}
            {props.customerData.customer_name ? `, ${props.customerData.customer_name}` : null}
          </BodyText>
          <BodyText forceWrap size={'sm'} margin={{ bottom: 'xxs' }}>
            {props.customerData.person.email || ''}
          </BodyText>
          <BodyText forceWrap size={'sm'} margin={{ bottom: 'xxs' }}>
            {createPhoneNumber(props.customerData.person.phone_number || '', props.customerData.person.country_calling_code)}
          </BodyText>
        </>
      )}

      {props.contactOrDelivery === 'delivery' && (
        <>
          <BodyText shown={!!props.customerData.person.given_name} forceWrap size={'sm'} margin={{ bottom: 'xxs' }}>
            {props.customerData.person.given_name} {props.customerData.person.family_name}
          </BodyText>
          <BodyText shown={!!props.customerData.person.email} forceWrap size={'sm'} margin={{ bottom: 'xxs' }}>
            {props.customerData.person.email}
          </BodyText>

          <BodyText shown={!!props.customerData.person.phone_number} forceWrap size={'sm'} margin={{ bottom: 'xxs' }}>
            {createPhoneNumber(props.customerData.person.phone_number || '', props.customerData.person.country_calling_code)}
          </BodyText>

          <BodyText shown={!!props.customerData.address?.address_2} forceWrap size={'sm'} margin={{ bottom: 'xxs' }}>
            {props.customerData.address?.address_2 ?? ''}
          </BodyText>

          <BodyText shown={!!props.customerData.address?.address_3} forceWrap size={'sm'} margin={{ bottom: 'xxs' }}>
            {props.customerData.address?.address_3 ?? ''}
          </BodyText>

          <BodyText shown={!!props.customerData.address?.address_1} forceWrap size={'sm'} margin={{ bottom: 'xxs' }}>
            {props.customerData.address?.address_1 ?? ''}
          </BodyText>

          <BodyText shown={!!props.customerData.address?.city} forceWrap size={'sm'} margin={{ bottom: 'xxs' }}>
            {props.customerData.address?.zip} {props.customerData.address?.city},{' '}
            {mapCountryValue(props.customerData.address?.country || '', 'fullName')}
          </BodyText>
        </>
      )}
    </>
  );
};
